import React, { Component } from 'react';
import PreLoginPage from '../../../views/core/PreLoginPage';
import $ from 'jquery';
// import MobileLogin from './MobileLogin';

export default class RemedialComponent extends PreLoginPage {
  constructor(props) {
    super(props);
    this.state = {
        screenNo:0
    }
  }

  componentDidMount() {
    this.appendCSS("./vendors/remedial.css");
    //console.log("props ",this.props)
    $(".PreLogin header").css("display","none");
  }

  incrementFn = (no,evt) => {
    let page = !isNaN(no) ? no : 0;
    this.setState({screenNo:page});
  }

  loginScreen = () => {
    console.warn("loginScreen");
    if(typeof this.props.loginScreen === "function"){
        this.props.loginScreen()
    }
  }


  screenFn1 = () => {
      return(
        <div className="cont">
        <h1>Learning Gaps post COVID</h1>
        <div className="description">One major problem resulting from school closures is that majority of students are carrying forward learning gaps in Mathematics into the 2021 academic year.</div>
        <button className="next" onClick={this.incrementFn.bind(this,1)}>Next</button>
        <div onClick={this.incrementFn.bind(this,1)} className="dots">
            <span className="dot blue"></span>
            <span className="dot"></span>
            <span className="dot"></span>
        </div>
        </div>
      )
  }

  screenFn2 = () => {
    return(
        <div className="cont">
        <h1>Our Proven Bridge Programs</h1>
        <div className="description">Developed in collaboration with the University of Cambridge, HeyMath! has 20 years of experience in designing bridge programs that offer remedial support to students.</div>
        <button className="next" onClick={this.incrementFn.bind(this,2)}>Next</button>
        <div onClick={this.incrementFn.bind(this,2)} className="dots">
            <span className="dot"></span>
            <span className="dot blue"></span>
            <span className="dot"></span>
        </div>
    </div>
    )
 }

    screenFn3 = () => {
      //debugger;
        return(
        <div className="cont">
        <h1>Stronger Foundation for 2021</h1>
              <div className="description">
              Over 1 million students have benefitted from HeyMath’s Bridge programs.
              </div>
              <button className="continue" onClick={this.loginScreen}>Continue</button>              
              <div onClick={this.incrementFn.bind(this,3)} className="dots">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot blue"></span>
        </div>
        </div>
        )
    }

  renderScreen = () => {
      let screenNo = this.state.screenNo;
      if(screenNo<3){
        switch(screenNo){
            case 0:
            return this.screenFn1()
            case 1:
            return this.screenFn2()
            case 2:
            return this.screenFn3()
            default:
            return this.screenFn1()
        }
      }
  }



  render() {
    return (
      <div id="remedialApp" className="remedial">
          <div className="remedialslick">
         {this.renderScreen()}
          </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/prelogin/src/components/RemedialComponent.js